document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    
    accordionHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const accordionBody = this.nextElementSibling;
            
            this.setAttribute('aria-expanded', !isExpanded);
            
            if (isExpanded) {
                accordionBody.setAttribute('hidden', '');
            } else {
                accordionBody.removeAttribute('hidden');
            }
        });
    });
});